import { jsx as _jsx } from "react/jsx-runtime";
import MuiImageList from '@mui/material/ImageList';
import MuiImageListItem from '@mui/material/ImageListItem';
import * as React from 'react';
import { Image } from '../image';
import { styled } from '../styled';
const StyledImageList = styled(MuiImageList)(({ $gap, $maxWidth }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    gap: $gap ?? 8,
    margin: 0,
    padding: 0,
    listStyle: 'none',
    maxWidth: $maxWidth
}));
const StyledImageListItem = styled(MuiImageListItem)(({ theme, $imageWidth, $imageHeight, $borderRadius }) => ({
    overflow: 'hidden',
    borderRadius: $borderRadius ?? theme.shape.borderRadius,
    flexShrink: 0,
    width: $imageWidth ?? 124,
    height: $imageHeight ?? 124
}));
export const ImageList = React.forwardRef((props, ref) => {
    const { gap = 8, 'aria-label': ariaLabel, images, cols, imageWidth = 124, imageHeight = 124, borderRadius, ...muiProps } = props;
    const maxCols = cols ?? 6;
    const calculatedMaxWidth = imageWidth * maxCols + gap * (maxCols - 1);
    return (_jsx(StyledImageList, { ref: ref, "data-role": "image-list", "$gap": gap, "$maxWidth": calculatedMaxWidth, "aria-label": ariaLabel, ...muiProps, children: images.map((image, index) => (_jsx(StyledImageListItem, { "data-role": "image-list-item", "$imageWidth": image.width ?? imageWidth, "$imageHeight": image.height ?? imageHeight, "$borderRadius": borderRadius, children: _jsx(Image, { ...image, width: image.width ?? imageWidth, height: image.height ?? imageHeight }) }, `${image.src}-${index}`))) }));
});
